module.exports = __webpack_public_path__ + "img/lightmode_vascularity.16eb2e95.png";